import { pollSkeletonStyle as styles } from "./pollSkeletonStyle";

const PollSkeleton = ({ count = 3, isLiveGame = false }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={`${isLiveGame ? "bg-themeOverlay" : "bg-themeShadowColor"} ${styles.skeleton}`} />
      ))}
    </>
  );
};

export default PollSkeleton;
